import _ from 'lodash';
import React, { Component } from 'react';
import MODE from '$components/review/mode';
import STEP from '$components/review/step';
import logoSrc from '$assets/logoAllWhite.png';
import styles from './styles.scss';

class ReviewHeader extends Component {
  renderExamMenu() {
    const { handleOpenExamNavigation } = this.props;
    return (
      <div
        data-aaa="actionJump"
        className={styles.actionWrapper}
        onClick={handleOpenExamNavigation}
      >
        Jump <i className="fad fa-map-marked-alt" />
      </div>
    );
  }

  renderExit() {
    const { handleExit } = this.props;
    return (
      <div data-aaa="actionExit" className={styles.actionWrapper} onClick={handleExit}>
        Exit <i className="fad fa-sign-out" />
      </div>
    );
  }

  renderFinish() {
    const { handleFinish } = this.props;
    return (
      <div
        data-aaa="actionFinish"
        className={styles.actionWrapper}
        onClick={handleFinish}
      >
        Finish <i className="fad fa-flag-checkered" />
      </div>
    );
  }

  renderAction() {
    const { mode, quizState } = this.props;
    const { step, essayResponse } = quizState;

    switch (step) {
      case STEP.quizPrompt: {
        if (mode === MODE.exam) {
          return this.renderExamMenu();
        }

        return this.renderFinish();
      }
      case STEP.examReview:
      case STEP.examSummary: {
        return this.renderExamMenu();
      }
      case STEP.essayInstructions:
      case STEP.essayReview:
      case STEP.sessionOptions:
      case STEP.sessionSelect: {
        return this.renderExit();
      }
      case STEP.quizConfirmation:
      case STEP.quizExplanation: {
        if (mode === MODE.exam) {
          return this.renderExamMenu();
        }

        return this.renderFinish();
      }
      case STEP.essayWriting: {
        if (_.get(essayResponse, 'submitAt')) {
          return this.renderExit();
        }

        return null;
      }
      default: {
        return null;
      }
    }
  }

  render() {
    return (
      <div className={styles.layout}>
        <div className={styles.logoContainer}>
          <img className={styles.logoImg} src={logoSrc} />
          <div className={styles.logoText}>Achievable</div>
        </div>
        <div className={styles.action}>{this.renderAction()}</div>
      </div>
    );
  }
}

export default ReviewHeader;
